// Pure decision logic for the stale-bundle reloader (src/utils/versionCheck.js),
// split out so it can be unit-tested without a browser or webpack aliases.
//
// Returns one of:
//   'noop'   — up to date, no server id, or already reloaded for this id (loop guard)
//   'reload' — stale and safe to reload now
//   'defer'  — stale but a text field is focused; reload once it's safe
export function decideReload({ bakedId, serverId, isSafe, alreadyReloadedFor }) {
  if (!serverId || serverId === bakedId) return "noop";
  if (alreadyReloadedFor === serverId) return "noop"; // reloaded once already → don't loop
  return isSafe ? "reload" : "defer";
}
